import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import { EventTime } from 'src/components/leaderboards/EventTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useDateFormatter } from 'src/hooks/useDateFormatter';
import { usePrizeFormat } from 'src/hooks/usePrizeFormat';
import { CheckInProps } from './useCheckInDialog';
import {
  WizardElementProps,
  withoutWizardProps,
} from 'src/components/wizard/Wizard';
import { useCheckIn } from 'src/components/tournaments/check-in/CheckInContext';
import Button from '@mui/material/Button';

export const EntryDialog = withoutWizardProps(
  ({ go }: WizardElementProps<CheckInProps>) => {
    const { gameTitle, prize, title, date, readyTime } = useCheckIn();
    const format = useDateFormatter();
    const dateFormatted = format(date);
    const prizeFormatted = usePrizeFormat(prize);
    return (
      <>
        <DialogTitle sx={{ color: 'black', textAlign: 'center' }}>
          {
            <GradientTypography
              gradientColor="primary.vertical"
              variant="h4"
              sx={{ textTransform: 'uppercase' }}
            >
              Tournament Check-In
            </GradientTypography>
          }
        </DialogTitle>
        <DialogContent sx={{ backgroundImage: 'none' }}>
          <Typography variant="h6" sx={{ pb: 4 }}>
            You registered for the {gameTitle}
            <GradientTypography
              variant="h6"
              gradientColor="warning.vertical"
              sx={{ display: 'inline', textTransform: 'uppercase', px: 1.5 }}
            >
              {prize ? `${prizeFormatted} ` : ''}
              {title} {dateFormatted}
            </GradientTypography>
            tournament. Check in by:
          </Typography>
          <EventTime date={readyTime} title="" />
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: 'center', pt: 8, px: 0, pb: 0, width: '100%' }}
        >
          <Button
            variant="contained"
            size="large"
            onClick={() => {
              return go('RulesCheckInDialog');
            }}
            sx={{ flex: 2 }}
            endIcon={<CheckCircleOutlineIcon />}
          >
            Check-in
          </Button>
          <Button
            variant="contained"
            color="error"
            size="large"
            onClick={() => {
              return go('UnregisterGuardDialog');
            }}
            sx={{ flex: 1 }}
            endIcon={<HighlightOffIcon />}
          >
            Unregister
          </Button>
        </DialogActions>
      </>
    );
  },
);
